
const searchPlaceholderMapper = (filter) => {
  switch (filter) {
  case 'LEIREC_FULLTEXT':
    return 'Search in LEI, Names, BIC, Addresses'
  case 'LEIREC_OWNED_BY':
    return 'Find children of this legal entity'
  case 'LEIREC_OWNS':
    return 'Find parent entities of this legal entity'

  default:
    return 'Search for LEI, legal name or other data fields'
  }
}

export default searchPlaceholderMapper



// WEBPACK FOOTER //
// ./src/utils/searchPlaceholderMapper.js